import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/cspConfig/cspConfig.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './csp-config-form.scss';
import { FormLayout } from 'components/FormLayout';

type Props = {
  template: FormTemplate,
  data: Partial<types.CspConfig>
  i18nKeyPrefix?: string
  onFieldUpdate?: (param: FieldUpdateHandlerParam) => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.CspConfig
}

export const CSP_CONFIG_I18N_KEY = 'cspConfig.form';

export const CspConfigForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = CSP_CONFIG_I18N_KEY,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const formValues: types.CspConfig = {
      ...mainRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  return (
    <div className="csp-config-form" data-testid="CspConfigForm">
      <FormLayout>
        <Form
          ref={mainRef}
          name={template.formId ?? template.key}
          defaults={data}
          fields={(template.main as FormTemplateSection).fields}
          layout={(template.main as FormTemplateSection).metadata.layout?.rows}
          fieldUpdateHandler={onFieldUpdate}
          i18nKeyPrefix={i18nKeyPrefix}
        />
      </FormLayout>
    </div>
  );
});

export default CspConfigForm;
